import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
import { ArrowRight } from 'lucide-react';
import { useCalendarRaces, RACE_TYPES } from '@/hooks/useCalendarRaces';

export default function UpcomingRacesRibbon() {
  const navigate = useNavigate();
  const { data: races = [] } = useCalendarRaces();

  const next = useMemo(() => {
    const now = Date.now();
    return races.filter((r) => r.date.getTime() >= now).slice(0, 10);
  }, [races]);

  if (next.length === 0) return null;

  const goCalendar = () => navigate('/calendrier');

  return (
    <div className="border-y border-white/5 bg-background/80 backdrop-blur-sm">
      <div className="container mx-auto px-4 lg:px-8 py-2.5 lg:py-3 flex items-center gap-4">
        <div className="hidden sm:inline-flex items-center gap-2 shrink-0 font-mono text-[10px] tracking-[0.18em] uppercase text-muted-foreground">
          <span className="relative flex h-1.5 w-1.5">
            <span className="absolute inline-flex h-full w-full rounded-full bg-primary opacity-75 animate-ping" />
            <span className="relative inline-flex rounded-full h-1.5 w-1.5 bg-primary" />
          </span>
          PROCHAINES COURSES
        </div>
        <div className="flex items-stretch gap-2 overflow-x-auto scrollbar-hide flex-1 pb-0.5 -mx-1 px-1">
          {next.map((r) => {
            const t = RACE_TYPES[r.type];
            return (
              <button
                key={r.id}
                type="button"
                onClick={goCalendar}
                title={`${r.title}${r.city ? ` — ${r.city}` : ''}`}
                className="shrink-0 inline-flex items-center gap-2.5 rounded-[10px] border px-2.5 py-1.5 text-left transition-colors bg-white/[0.02] hover:bg-white/[0.05]"
                style={{ borderColor: 'rgba(255,255,255,0.06)' }}
              >
                <span
                  className="flex flex-col items-center justify-center px-2 py-0.5 rounded-md min-w-[36px]"
                  style={{ background: 'rgba(0,0,0,0.35)', borderLeft: `3px solid ${t.color}` }}
                >
                  <span
                    className="font-display italic font-extrabold leading-none tabular-nums tracking-tight"
                    style={{ color: t.color, fontSize: 18 }}
                  >
                    {format(r.date, 'dd')}
                  </span>
                  <span className="font-mono text-[8px] tracking-[0.14em] uppercase text-muted-foreground/70 mt-0.5">
                    {format(r.date, 'MMM', { locale: fr }).toUpperCase()}
                  </span>
                </span>
                <span className="flex flex-col gap-0.5 min-w-0">
                  <span className="text-[12px] font-bold text-foreground whitespace-nowrap truncate max-w-[200px]">
                    {r.title}
                  </span>
                  <span className="font-mono text-[9px] tracking-[0.1em] uppercase text-muted-foreground whitespace-nowrap">
                    {r.km || '?'} KM · {t.label}
                  </span>
                </span>
              </button>
            );
          })}
        </div>
        <button
          type="button"
          onClick={goCalendar}
          className="hidden lg:inline-flex shrink-0 items-center gap-1 font-mono text-[10px] tracking-[0.16em] uppercase text-primary whitespace-nowrap hover:opacity-80 transition-opacity"
        >
          TOUT VOIR · {races.length} <ArrowRight className="h-2.5 w-2.5" />
        </button>
      </div>
    </div>
  );
}